import { render, staticRenderFns } from "./NotificationAdministratorIcon.vue?vue&type=template&id=9150e7d6&"
import script from "./NotificationAdministratorIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationAdministratorIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports